/* eslint-disable no-nested-ternary */
import format from "date-fns/format";
import { keyBy } from "lodash/fp";
import {
  ALL_DATES,
  INTEGER_KEYS,
  AppliedFilterLabelMap,
  DATES,
  DROPDOWN_KEYS,
  DROPDOWN_REDUX_KEY_MAPPER,
  EXCLUDE_DATES,
  OS_DROPDOWN_KEYS,
} from "../../../contants";
import { ROUTES } from "../../../utils/constants";
import { isEmptyObj, isOSKey } from "../../../utils/helper";

const DATE_FORMAT = "yyyy-MM-dd hh':'mm':'ss";
const PLUS = "plus";
const OS_LABEL = "organisationStructure";
export const POSITIONS_KEY = "dualPositionIds";
export const MAINLINE_POSITION_KEY = "mainlinePositionIds";
export const GOHONZON = "gohonzonTypes";
export const ROLE = "roleIds";

// ✅ Add Exam Level Mapping
const ExamLevelMap = {
  52: "Entrance",
  51: "Introductory",
  53: "Intermediate",
  38: "Advanced",
};

export const performOperation = (value, limit, operator = PLUS) =>
  operator === PLUS ? Number(value) + limit : Number(value) - limit;

export const getRoutePath = () => ROUTES.MEMBER_SEARCH.path;

export const getAdminRoutePath = () =>
  ROUTES.USER_MANAGEMENT_MEMBER_SEARCH.path;

const handlePositions = (queryObject, currObj, key) => {
  // const currentPositions = currObj[POSITIONS_KEY] ?? [];

  const keyValue = queryObject[key]
    ? queryObject[key].split(",").map(Number)
    : [];

  return [...keyValue];
};

const handleOS = (queryObject, currObj, key) => {
  const currentOS = currObj[OS_LABEL] ?? {};

  return Object.assign(currObj, {
    [OS_LABEL]: { ...currentOS, [key]: Number(queryObject[key]) },
  });
};

export const getFormattedQuery = (queryObject) =>
  !isEmptyObj(queryObject)
    ? Object.keys(queryObject).reduce((acc, currKey) => {
        let value = queryObject[currKey];

        console.log("value", value);
        // const key = currKey === MAINLINE_POSITION_KEY ? POSITIONS_KEY : currKey;

        if (INTEGER_KEYS.includes(currKey)) {
          value = Number(queryObject[currKey]);
        } else if (ALL_DATES.includes(currKey)) {
          value = format(new Date(queryObject[currKey]), DATE_FORMAT);
        } else if (POSITIONS_KEY === currKey) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (MAINLINE_POSITION_KEY === currKey) {
          value = handlePositions(queryObject, acc, currKey);
        } else if (OS_DROPDOWN_KEYS.includes(currKey)) {
          return handleOS(queryObject, acc, currKey);
        } else if (currKey === "gohonzonTypes") {
          const currentGohonzonTypes = acc.gohonzonTypes || [];
          const keyValue = queryObject[currKey]
            ? queryObject[currKey].split(",").map((type) => type.trim())
            : [];
          value = [...currentGohonzonTypes, ...keyValue];
        }
        return Object.assign(acc, {
          [currKey]: value,
        });
      }, {})
    : {};

export const getFilters = (queryObject, metaData, disabledOSKeys) =>
  Object.keys(queryObject).reduce((acc, curr) => {
    if (!EXCLUDE_DATES.includes(curr)) {
      // handle dates
      if (DATES.includes(curr)) {
        const key = curr.split("From")[0];
        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[key],
          value: `${queryObject[curr]} - ${queryObject[`${key}To`]}`,
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      if (GOHONZON.includes(curr)) {
        const key = curr;
        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[key],
          value: queryObject[curr].replace(/_/g, " "),
          disabled: disabledOSKeys.includes(curr),
        });
        return acc;
      }

      // ✅ Handle examDetailId - Add this before dropdown handling
      if (curr === "examDetailId") {
        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value: ExamLevelMap[queryObject[curr]] || queryObject[curr],
          disabled: disabledOSKeys?.includes(curr),
        });
        return acc;
      }

      // handle dropdowns
      if (DROPDOWN_KEYS.includes(curr) || OS_DROPDOWN_KEYS.includes(curr)) {
        const pool = isOSKey(curr)
          ? metaData.organisationStructure[DROPDOWN_REDUX_KEY_MAPPER[curr]]
          : metaData[DROPDOWN_REDUX_KEY_MAPPER[curr]];

        const selectedValue = pool?.find(
          (p) =>
            (p.structureId ||
              p.divisionId ||
              p.cityId ||
              p.stateId ||
              p.professionsId ||
              p.roleId ||
              p.specialGroupId) === Number(queryObject[curr])
        );

        console.log("selectedValue", selectedValue);

        // const nameParts = selectedValue.name.split("SI");
        // const formattedName = nameParts
        //   .map((part) => part.trim())
        //   .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        //   .join(" SI ");
        // console.log("nameParts", formattedName);

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value:
            selectedValue?.name ||
            selectedValue?.name ||
            selectedValue?.cityName ||
            selectedValue?.stateName ||
            selectedValue?.profession ||
            selectedValue?.name ||
            selectedValue?.roleName ||
            queryObject[curr],
          disabled: disabledOSKeys?.includes(curr),
        });
        return acc;
      }

      if ([POSITIONS_KEY, MAINLINE_POSITION_KEY].includes(curr)) {
        const positionsMap = keyBy("value", metaData.positions);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[curr],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      if (ROLE.includes(curr)) {
        const positionsMap = keyBy("value", metaData.roles);
        const inputPositions = queryObject[curr].split(",");

        const positionsLabel = inputPositions?.map(
          (postion) => positionsMap[postion]?.entityTitle
        );

        console.log("postion", inputPositions);

        const key = curr;
        console.log("curr", curr);
        acc.push({
          key: curr,
          displayName: AppliedFilterLabelMap[key],
          value: positionsLabel.join(", "),
        });
        return acc;
      }

      // rest
      acc.push({
        key: curr,
        displayName: AppliedFilterLabelMap[curr],
        value: queryObject[curr],
        disabled: disabledOSKeys.includes(curr),
      });
      return acc;
    }
    return acc;
  }, []);

export const handleDependencyFilter = (query) => {
  const updatedQueryWithOS = { ...query };
  if (!updatedQueryWithOS?.areaId) {
    delete updatedQueryWithOS.zoneId;
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.zoneId) {
    delete updatedQueryWithOS.regionId;
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.regionId) {
    delete updatedQueryWithOS.chapterId;
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.chapterId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  } else if (!updatedQueryWithOS?.districtId) {
    delete updatedQueryWithOS.districtId;
    delete updatedQueryWithOS.blockId;
  }

  // state and divisions
  if (!updatedQueryWithOS?.state) {
    delete updatedQueryWithOS.city;
  }
  if (!updatedQueryWithOS?.divisionId) {
    delete updatedQueryWithOS.subdivisionId;
    delete updatedQueryWithOS.specialGroupId;
  }

  return updatedQueryWithOS;
};
